import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';
import { Marker } from '@fragment/ui/src/components/List';
import { strictClassNames } from '@fragment/ui/src/components/utils';

type NavButtonProps = {
  onClick: () => void;
  label: string;
  isActive: boolean;
  testId: string;
  showMarker?: boolean;
} & (
  | {
      marker: 'numeric';
      ordinal: number;
    }
  | {
      marker: 'bullet';
      ordinal?: never;
    }
);

export const NavButton = ({
  onClick,
  marker,
  ordinal,
  label,
  isActive,
  testId,
  showMarker = true,
}: NavButtonProps) => (
  <TextButton
    onClick={onClick}
    extraClassNames={showMarker ? 'w-fit' : 'w-full'}
  >
    <div
      className={clsx(
        'flex flex-row items-center gap-x-f1 group',
        showMarker ? 'w-fit' : 'w-full rounded-[2px] font-helvetica',
        isActive && !showMarker && 'bg-main-100'
      )}
      data-testid={testId}
    >
      {showMarker && (
        <Marker
          type={marker}
          ordinal={ordinal ?? 0}
          color={strictClassNames(['text-main-500'])}
        />
      )}
      <span
        className={clsx(
          'text-main w-fit',
          !isActive && 'text-main-500',
          'group-hover:text-main'
        )}
      >
        {label}
      </span>
    </div>
  </TextButton>
);
